module.exports = __webpack_public_path__ + "static/media/donkey-kong.bb270da2.png";